import get from "lodash/get";
import React from "react";
import { getStoryElementByType, getStoryElementsByType } from "../../../utils/index.js";
import Profile from "../Profile";
import "./speakers-panel.m.css";

const SpeakersPanel = ({ card, cdnImage, customClassName }) => {
  const title = get(getStoryElementByType(card, "title"), "text", "");
  const textElements = getStoryElementsByType(card, "text");
  const description = get(textElements, "[0].text", "");
  const compositeElement = getStoryElementsByType(card, "composite");
  const profileElements =
    compositeElement.length > 0
      ? get(compositeElement, ["0", "story-elements"])
      : getStoryElementsByType(card, "image");
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  return (
    <div styleName="speakers-panel-container" data-model-id="12800:77517" id={`${id.toLowerCase()}`}>
      <div styleName="event-description" dangerouslySetInnerHTML={{ __html: title }} />

      <div styleName="divider" />

      <div styleName="div-2">
        <div styleName="speakers-description" dangerouslySetInnerHTML={{ __html: description }} />
      </div>

      <div styleName="div-3" className={customClassName}>
        {profileElements.map((element) => (
          <Profile
            image={`${cdnImage}/${element["image-s3-key"]}`}
            name={element.title}
            role={element["image-attribution"]}
            isSpeakerProfile={true}
          />
        ))}
      </div>
    </div>
  );
};

export default SpeakersPanel;
